<div class="card">
  <app-header
    titulo="Atualizar Consecana"
    descricao="Realizar a integração das parcelas futuras"
  ></app-header>


  <app-contratos statusContrato="FU" operacao="FU"></app-contratos>

</div>
